import { Button, Divider, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { useNotification } from '@/context/notification';
import type { PixPaymentData } from '@/data/catalog/offer/interfaces';
import { StyledBox } from '@/packages/courses/pages/checkout/components/styled-box';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

export const PixPaymentDetails = () => {
  const { toast } = useNotification();
  const { values, actions } = useCheckoutWizard();
  const paymentData = values[CheckoutStepIds.PixBankSlip]
    ?.paymentData as PixPaymentData;
  const qr_code_url = paymentData?.qr_code_url ?? '';
  const qr_code = paymentData?.qr_code ?? '';

  const handleCopyCode = () => {
    navigator.clipboard.writeText(qr_code);
    toast({
      content: 'Código copiado para a área de transferência',
      type: 'success',
    });
  };

  return (
    <ContentBox spacing={2}>
      <Typography variant="h3">Escaneie o código QR para pagar</Typography>
      <Stack spacing={1}>
        <Typography>
          1. Acesse seu internet Banking ou app de pagamentos.
        </Typography>
        <Typography>2. Escolha pagar via Pix.</Typography>
        <Typography>3. Escaneie o seguinte código:</Typography>
      </Stack>
      <Stack justifyContent="center" alignItems="center">
        <img src={qr_code_url} alt="QR Code" width={144} height={144} />
      </Stack>
      <Divider />
      <Typography variant="h3">
        Ou copie o código para fazer o pagamento
      </Typography>
      <Typography>
        Escolha pagar via Pix pelo seu Internet Banking ou app de pagamentos.
        Depois, cole o seguinte código:
      </Typography>
      <StyledBox>
        <Typography
          textAlign="center"
          sx={{ overflowWrap: 'break-word', wordBreak: 'break-all' }}
        >
          {qr_code}
        </Typography>
      </StyledBox>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={handleCopyCode}>
          Copiar código
        </Button>
        <Button onClick={() => actions.navigate(CheckoutStepIds.PaymentStatus)}>
          Já paguei
        </Button>
      </Stack>
    </ContentBox>
  );
};
